import { SuiPolicyEditor, type Policy } from "@/components/SuiPolicyEditor";

/**
 * Create-agent page (Sui). The guided stepper is self-contained (header, step
 * rail, full-width body, policy-object artifact, footer nav), so this page just
 * mounts it — no extra wrapper, no width clamp.
 */
export function SuiCreateAgentPage({ onSubmit }: { onSubmit?: (policy: Policy) => void }) {
  return <SuiPolicyEditor onSubmit={onSubmit} />;
}
